import { useCallback, useEffect, useMemo } from 'react';
import { debounce } from 'lodash-es';
import { GridApi } from 'ag-grid-community';

const DEBOUNCE_DELAY_MS = 300;

/**
 * Hook to handle debounced cell value changes for cap table subtotals
 * ag-Grid will automatically recalculate subtotals when cell values change
 * This hook provides a debounced callback to trigger grid updates
 */
export function useCapTableSubtotals(gridApi: GridApi | null) {
  const refreshGrid = useCallback(() => {
    if (!gridApi) {
      return;
    }
    // ag-Grid automatically recalculates aggregations when cell values change
    // We just need to ensure the grid refreshes to show updated totals
    gridApi.refreshCells({ force: true });
  }, [gridApi]);

  const handleCellValueChanged = useMemo(() => debounce(refreshGrid, DEBOUNCE_DELAY_MS), [refreshGrid]);

  // Cleanup debounced function on unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      handleCellValueChanged.cancel();
    };
  }, [handleCellValueChanged]);

  return {
    handleCellValueChanged,
  };
}
